var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1172 12.9997H26.1506V12.9499H15.3506V17.7499H22.1324C21.143 20.5441 18.4844 22.5499 15.3506 22.5499C11.3744 22.5499 8.15059 19.3261 8.15059 15.3499C8.15059 11.3737 11.3744 8.14985 15.3506 8.14985C17.186 8.14985 18.8558 8.84225 20.1272 9.97325L23.5214 6.57905C21.3782 4.58165 18.5114 3.34985 15.3506 3.34985C8.72359 3.34985 3.35059 8.72285 3.35059 15.3499C3.35059 21.9769 8.72359 27.3499 15.3506 27.3499C21.9776 27.3499 27.3506 21.9769 27.3506 15.3499C27.3506 14.5453 27.2678 13.7599 27.1172 12.9997Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73438 9.76445L8.67697 12.6559C9.74377 10.0147 12.3274 8.14985 15.3508 8.14985C17.1862 8.14985 18.856 8.84225 20.1274 9.97325L23.5216 6.57905C21.3784 4.58165 18.5116 3.34985 15.3508 3.34985C10.7416 3.34985 6.74437 5.95205 4.73438 9.76445Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.35 27.3498C18.4496 27.3498 21.266 26.1636 23.3954 24.2346L19.6814 21.0918C18.4361 22.0389 16.9145 22.5511 15.35 22.5498C12.2288 22.5498 9.57859 20.5596 8.58019 17.7822L4.66699 20.7972C6.65299 24.6834 10.6862 27.3498 15.35 27.3498Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1172 12.9998H26.1506V12.95H15.3506V17.75H22.1324C21.6591 19.0798 20.8066 20.2419 19.6802 21.0926L19.682 21.0914L23.396 24.2341C23.1332 24.4729 27.3506 21.35 27.3506 15.35C27.3506 14.5454 27.2678 13.76 27.1172 12.9998Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c15b4bc6034993912b66ccff81f5ef55.svg";
export { ForwardRef as ReactComponent };